import userReducer from '@app/store/slices/userSlice';
import authReducer from '@app/store/slices/authSlice';
import nightModeReducer from '@app/store/slices/nightModeSlice';
import themeReducer from '@app/store/slices/themeSlice';
import pwaReducer from '@app/store/slices/pwaSlice';
import newsReducer from '@app/store/slices/newsSlice';
import blogReducer from '@app/store/slices/blogSlice';
import pagesReducer from '@app/store/slices/pagesSlice';
import slidersReducer from '@app/store/slices/slidersSlice';
import announcementsReducer from '@app/store/slices/announcementsSlice';
import usersReducer from '@app/store/slices/usersSlice';
import mediaReducer from '@app/store/slices/mediaSlice';
import menuReducer from '@app/store/slices/menuSlice';
import contactFormReducer from '@app/store/slices/contactFormSlice';

export default {
  user: userReducer,
  auth: authReducer,
  nightMode: nightModeReducer,
  theme: themeReducer,
  pwa: pwaReducer,
  news: newsReducer,
  blog: blogReducer,
  pages: pagesReducer,
  sliders: slidersReducer,
  announcements: announcementsReducer,
  users: usersReducer,
  media: mediaReducer,
  menu: menuReducer,
  contactForm: contactFormReducer,
};
